import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"

export const Testimonials = () => {
  const [theme, setTheme] = React.useState<string | null>("")
  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem("theme")
      setTheme(currentTheme)
    }, 500)

    return () => clearInterval(interval)
  }, [])
  return (
    <div
      className={` ${theme == "glassy" ? "bg-testimonial-primary" : theme === "light" ? "bg-completedProject" : theme === "dark" ? "bg-completedProject" : "bg-testimonial-primary"}`}
    >
      <div className="container mx-auto py-10 my-10 px-3">
        <div className="flex items-center gap-3">
          <div className="px-2 h-[1px] bg-[#7B68EC]"></div>
          <p className="text-[#7B68EC] uppercase tracking-wider">
            Testimonials
          </p>
        </div>
        <div className="pt-3">
          <h2 className="text-2xl font-light text-black">
            What our Clients are <br />
          </h2>
          <p className="font-medium text-black text-3xl pt-2"> Saying!</p>
        </div>
        <div className="flex items-center text-end gap-2 justify-end">
          <Link to="/our-client-reviews" className="text-[#7B68EC]">
            See All Testimonials
          </Link>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="15"
              viewBox="0 0 17 15"
              fill="none"
            >
              <path
                d="M1 14L7 7.5L1 1"
                stroke="#7B68EC"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10 14L16 7.5L10 1"
                stroke="#7B68EC"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
        <div
          className={`shadow-xl rounded-xl p-3 mt-10 ${theme == "glassy" ? "bg-[linear-gradient(209.5deg, rgba(243, 185, 0, 0.13) 0%, rgba(194, 117, 255, 0.29) 81.93%)]" : theme === "light" ? "bg-input" : theme === "dark" ? "bg-input" : ""}`}
        >
          <div className="flex gap-3 items-center">
            <div>
              <StaticImage
                placeholder="blurred"
                className="lg:w-8 w-4 rounded-full"
                src="./client.png"
                alt="client"
              />
            </div>
            <div>
              <p className="text-black font-semibold">
                Based on your experience, how would you rate your partnership
                with Visual Folio?
              </p>
            </div>
          </div>
          <div className="flex lg:flex-row flex-col items-center justify-between px-5 py-2">
            <div className="mt-3 flex lg:flex-row flex-col gap-4 items-center">
              <div className="flex flex-wrap gap-4 items-center">
                <div
                  className={`lg:w-24 lg:h-24 w-20 h-20 flex items-center justify-center rounded-xl ${theme == "glassy" ? "bg-[#f4f4f450] border-[#7B68EC] border" : theme === "light" ? "bg-btn" : theme === "dark" ? "bg-btn" : "bg-[#f4f4f450] border-[#7B68EC] border"}`}
                >
                  <div>
                    <p className="text-center lg:text-3xl text-lg">😉</p>
                    <p className="text-xs text-gray">Very Good</p>
                  </div>
                </div>
                <div
                  className={`lg:w-24 lg:h-24 w-20 h-20 flex items-center justify-center rounded-xl ${theme == "glassy" ? "bg-[#f4f4f450]" : theme === "light" ? "bg-input" : theme === "dark" ? "bg-input" : "bg-[#f4f4f450]"}`}
                >
                  <div>
                    <p className="text-center text-3xl">😊</p>
                    <p className="text-xs text-gray">Good</p>
                  </div>
                </div>
                <div
                  className={`lg:w-24 lg:h-24 w-20 h-20 flex items-center justify-center rounded-xl ${theme == "glassy" ? "bg-[#f4f4f450]" : theme === "light" ? "bg-input" : theme === "dark" ? "bg-input" : "bg-[#f4f4f450]"}`}
                >
                  <div>
                    <p className="text-center text-3xl">🥴</p>
                    <p className="text-xs text-gray">Average</p>
                  </div>
                </div>
                <div
                  className={`lg:w-24 lg:h-24 w-20 h-20 flex items-center justify-center rounded-xl ${theme == "glassy" ? "bg-[#f4f4f450]" : theme === "light" ? "bg-input" : theme === "dark" ? "bg-input" : "bg-[#f4f4f450]"}`}
                >
                  <div>
                    <p className="text-center text-3xl">😔</p>
                    <p className="text-xs text-gray">Poor</p>
                  </div>
                </div>
                <div
                  className={`lg:w-24 lg:h-24 w-20 h-20 flex items-center justify-center rounded-xl ${theme == "glassy" ? "bg-[#f4f4f450]" : theme === "light" ? "bg-input" : theme === "dark" ? "bg-input" : "bg-[#f4f4f450]"}`}
                >
                  <div>
                    <p className="text-center text-3xl">😥</p>
                    <p className="text-xs text-gray">Very Poor</p>
                  </div>
                </div>
              </div>
              <div>
                <p className="font-medium text-black">Review and ratings</p>
              </div>
            </div>
            <div className="flex gap-2 items-center justify-end">
              <p className="font-semibold text-black text-4xl">5.0</p>
              <div>
                <p className="text-yellow-400 text-[22px] font-bold">
                  ★ ★ ★ ★ ★
                </p>
                <p className="text-xs text-gray">Based on 3000+ ratings</p>
              </div>
            </div>
          </div>
          <div className="mt-3 flex flex-wrap gap-4 items-center">
            <div
              className={`lg:w-[28%] px-2 py-3 flex items-center justify-center rounded-xl ${theme == "glassy" ? "bg-[#f4f4f450]" : theme === "light" ? "bg-input" : theme === "dark" ? "bg-input" : "bg-[#f4f4f450]"}`}
            >
              <p className="text-xs text-gray">
                Communication with Visual Folio Team
              </p>
            </div>
            <div
              className={`lg:w-[28%] px-2 py-3 flex items-center justify-center rounded-xl ${theme == "glassy" ? "bg-[#f4f4f450]" : theme === "light" ? "bg-input" : theme === "dark" ? "bg-input" : "bg-[#f4f4f450]"}`}
            >
              <p className="text-xs text-gray">Service as Described</p>
            </div>
            <div
              className={`lg:w-[28%] px-2 py-3 flex items-center justify-center rounded-xl ${theme == "glassy" ? "bg-[#f4f4f450]" : theme === "light" ? "bg-input" : theme === "dark" ? "bg-input" : "bg-[#f4f4f450]"}`}
            >
              <p className="text-xs text-gray">Buy again & recommend</p>
            </div>
          </div>
          <div>
            <p className="text-black font-bold my-3">Insight thoughts</p>
            <div
              className={`w-full py-3 flex items-center px-3 bg-[#f4f4f430] rounded-xl ${theme == "glassy" ? "bg-[#f4f4f430]" : theme === "light" ? "bg-input" : theme === "dark" ? "bg-input" : "bg-[#f4f4f430]"}`}
            >
              <p className="text-xs text-gray pt-3 pb-7">
                Visual Folio is a game-changer! Their team combines creativity,
                strategy, and cutting-edge technology to deliver outstanding
                digital solutions. From UI/UX design to full-stack development
                and SEO, every service is executed with precision and
                professionalism. Their transparent pricing and commitment to
                quality set them apart. They took our vision and turned it into
                a high-performing website that not only looks amazing but also
                drives real results. Their ongoing support and responsiveness
                make them a trusted partner for any business looking to grow
                online. Highly recommended!
              </p>
            </div>
          </div>
        </div>
        <div
          className={` rounded-xl p-3 mt-5 ${theme == "glassy" ? "bg-[linear-gradient(209.5deg, rgba(243, 185, 0, 0.13) 0%, rgba(194, 117, 255, 0.29) 81.93%)]" : theme === "light" ? "bg-input" : theme === "dark" ? "bg-input" : "bg-[#f4f4f450]"}`}
        >
          <div className="flex gap-3 items-center">
            <div>
              <StaticImage
                placeholder="blurred"
                className="lg:w-8 w-4 rounded-full"
                src="./client.png"
                alt="client"
              />
            </div>
            <div>
              <p className="text-black font-semibold">
                How was it working with the Visual Folio?
              </p>
            </div>
          </div>
        </div>
        <div
          className={` rounded-xl p-3 mt-5 ${theme == "glassy" ? "bg-[linear-gradient(209.5deg, rgba(243, 185, 0, 0.13) 0%, rgba(194, 117, 255, 0.29) 81.93%)]" : theme === "light" ? "bg-input" : theme === "dark" ? "bg-input" : "bg-[#f4f4f450]"}`}
        >
          <div className="flex gap-3 items-center">
            <div>
              <StaticImage
                placeholder="blurred"
                className="lg:w-8 w-4 rounded-full"
                src="./client.png"
                alt="client"
              />
            </div>
            <div>
              <p className="text-black font-semibold">
                How would you rate the value of your time & work with the Visual
                Folio?
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
